export default function InputLabel(theme) {
    return {
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    color: theme.palette.grey[600]
                },
                outlined: {
                    lineHeight: '0.8em',
                    '&.MuiInputLabel-root': {
                        transform: 'translate(14px, 11px) scale(1)',
                        lineHeight: '0.8em'
                    },
                    '&.MuiInputLabel-sizeSmall': {
                        lineHeight: '1em'
                    },
                    '&.MuiInputLabel-shrink': {
                        background: theme.palette.background.paper,
                        padding: '0 8px',
                        marginLeft: -6,
                        lineHeight: '18px',
                        transform: 'translate(14px, -9px) scale(0.75)'
                    }
                }
            }
        }
    };
}
